import React, { useContext, useState } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import WizardBackButton from '@Components/WizardFlow/WizardBackButton'
import WizardNextButton from '@Components/WizardFlow/WizardNextButton'
import WizardNavigationBarLayout from '@Components/WizardFlow/WizardNavigationBarLayout'
import ModalPortal from '@Components/Popups/ModalPortal'
import { observer } from 'mobx-react'
import ClaimNoPublishersPopup from '@Components/ClaimComponents/ClaimNoPublishersPopup'
import ClaimConfirmationPopup from '@Components/ClaimComponents/ClaimConfirmationPopup'
import OverclaimWarningStep from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep'
import WizardSubmitButton from '@Components/WizardFlow/WizardSubmitButton'

const ClaimWizardNavigationBar = () => {
    const { workStore, wizardFlowStore, userStore, claimToolStore } = useContext<RootStore>(StoresContext)

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
    const [submissionLoading, setSubmissionLoading] = useState<boolean>(false)

    const showSubmitButton = wizardFlowStore.currentIndex === wizardFlowStore.flowLength - 2

    const showNavBar = wizardFlowStore.currentIndex > 0 && wizardFlowStore.currentIndex < wizardFlowStore.flowLength - 1

    const onSubmitButtonPressed = () => {
        setModalIsOpen(true)
    }

    const onOverclaimWarningConfirm = () => {
        workStore.setOverclaimWarningOpen(false)
        showSubmitButton ? onSubmitButtonPressed() : wizardFlowStore.advanceIndex()
    }

    const LeftContent = (
        <>
            {wizardFlowStore.currentIndex === 0 && <div className="invisible-alignment-div" />}
            {wizardFlowStore.currentIndex > 0 && <WizardBackButton />}
        </>
    )

    const MiddleContent = <></>

    const RightContent = (
        <>
            {wizardFlowStore.currentIndex > 0 && (
                <>
                    {showSubmitButton ? (
                        <WizardSubmitButton onSubmitButtonPressed={onSubmitButtonPressed} buttonText="Claim" />
                    ) : (
                        <WizardNextButton disabled={!workStore.wizardStepIsValid} />
                    )}
                </>
            )}
        </>
    )

    const submitClaim = async () => {
        setSubmissionLoading(true)
        const updatedClaimSubmitted = await claimToolStore.submitClaim()
        workStore.setWorkDraftToLocal(updatedClaimSubmitted)
        setSubmissionLoading(false)
        setModalIsOpen(false)
        wizardFlowStore.advanceIndex()
    }

    return (
        <>
            {showNavBar && (
                <WizardNavigationBarLayout
                    leftContent={LeftContent}
                    middleContent={MiddleContent}
                    rightContent={RightContent}
                />
            )}

            <ModalPortal isOpen={claimToolStore.invalidPublishers}>
                <ClaimNoPublishersPopup
                    closeModal={() => {
                        claimToolStore.setInvalidPublishers(false)
                    }}
                />
            </ModalPortal>

            <ModalPortal isOpen={modalIsOpen}>
                <ClaimConfirmationPopup
                    closeModal={() => setModalIsOpen(false)}
                    isInternal={userStore.isInternal}
                    submissionLoading={submissionLoading}
                    submitClaim={submitClaim}
                />
            </ModalPortal>

            <ModalPortal isOpen={workStore.overclaimWarningOpen}>
                <OverclaimWarningStep
                    onClickConfirm={onOverclaimWarningConfirm}
                    onClickCancel={() => workStore.setOverclaimWarningOpen(false)}
                />
            </ModalPortal>
        </>
    )
}

export default observer(ClaimWizardNavigationBar)
